import { render, staticRenderFns } from "./Ticket-form.vue?vue&type=template&id=58b5b778&scoped=true"
import script from "./Ticket-form.vue?vue&type=script&lang=js"
export * from "./Ticket-form.vue?vue&type=script&lang=js"
import style0 from "./Ticket-form.vue?vue&type=style&index=0&id=58b5b778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5b778",
  null
  
)

export default component.exports